<template>
  <div :class="['vcircle_label', { disabled: disabled }]" @click="$emit('input', !value)">
    <vcircle v-tooltip="tooltip" :value="value" :disabled="disabled" />

    <div class="circle_label">{{ computedLabel }}</div>
  </div>
</template>

<script>
import { isNumeric } from '@/_helpers/utils.js';
/*
  @ complex component
  @ props: value(any), label(string)
  @ emit: input
*/
export default {
  name: 'VcircleLabel',

  props: {
    value: {
      type: [Boolean],
      required: true
    },

    label: {
      type: [String, Number],
      default: ''
    },

    tooltip: {
      type: [Object],
      default: null
    },

    disabled: {
      type: [Boolean],
      default: false
    }
  },

  computed: {
    computedLabel() {
      if (isNumeric(this.label)) {
        return Intl.NumberFormat('ru-RU').format(this.label);
      }

      return this.label;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.vcircle_label {
  display: flex;
  align-items: center;
  padding: 7px 10px 7px 12px;

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  .circle_label {
    @include mixin-text-main;
    color: #000;
    width: 100%;
    box-sizing: border-box;
    margin-left: 10px;
  }
}
</style>
